import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/other-pages/not-found/not-found.component';
import {WebsiteLayoutComponent} from './layout/website-layout/website-layout.component';
import {WEBSITE_ROUTES} from './features/website/website.routes';

export const routes: Routes = [

  /* =======================
   * WEBSITE (PUBLIC)
   * ======================= */
  {
    path: '',
    component: WebsiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/website/website.routes')
            .then(m => m.WEBSITE_ROUTES),
      },
    ],
  },

  /* =======================
   * AUTH
   * ======================= */
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component')
            .then(c => c.LoginComponent),
      },
    ],
  },

  /* =======================
   * ADMIN (PROTECTED)
   * ======================= */
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/events/events.routes')
            .then(m => m.EVENTS_ROUTES),
      },
    ],
  },

  /* =======================
   * OTHER
   * ======================= */
  {
    path: 'organizer-register',
    loadComponent: () =>
      import('./features/auth/organizer-register/organizer-register.component')
        .then(c => c.OrganizerRegisterComponent),
  },

  {
    path: '**',
    component: NotFoundComponent,
  },
];

